/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */

import ih from 'immutability-helper';
import { cloneDeep, keyBy } from 'lodash';

import * as types from './actionTypes';
import {
  UPDATE_FIELD_SUCCESS,
  SYNC_FIELDS_SUCCESS,
} from '../fields/actionTypes';
import initialState from './initialState';
import { SELECT_PROJECT } from '../../services/project/actionTypes';

const updateFieldsList = (fieldsList, updatedField) =>
  fieldsList.map(field =>
    ih(field, {
      $set: field.id === updatedField.id ? updatedField : field,
    }),
  );

export const updateFieldsNames = (fields, updatedFields) =>
  fields.map(field => {
    const updatedField = updatedFields.find(f => f.id === field.id);
    return updatedField
      ? ih(field, { name: { $set: updatedField.name } })
      : field;
  });

const handleSyncFieldsSuccess = (state, action) => {
  const updatedFields = action.payload.updated;
  return ih(state, {
    show: {
      data: {
        $apply: data =>
          Object.entries(data).reduce((acc, [actionId, actionData]) => {
            const updatedActionData = { ...actionData };

            updatedActionData.fields = actionData.fields
              ? updateFieldsNames(actionData.fields, updatedFields)
              : null;

            if (actionData.custom_module_call) {
              updatedActionData.custom_module_call = {
                input_fields: updateFieldsNames(
                  actionData.custom_module_call.input_fields,
                  updatedFields,
                ),
                output_fields: updateFieldsNames(
                  actionData.custom_module_call.output_fields,
                  updatedFields,
                ),
              };
            }

            acc[actionId] = updatedActionData;
            return acc;
          }, {}),
      },
    },
  });
};

export default (state = cloneDeep(initialState), action = {}) => {
  switch (action.type) {
    case types.GET_ACTIONS_REQUEST:
      return ih(state, {
        list: {
          isLoading: { $set: true },
        },
      });
    case types.GET_ACTIONS_SUCCESS:
      return ih(state, {
        list: {
          $merge: {
            isLoading: false,
            data: action.payload.actions,
          },
        },
      });
    case types.GET_ACTIONS_ERROR:
      return ih(state, {
        list: {
          $merge: {
            isLoading: false,
            error: action.payload.error,
          },
        },
      });
    case types.ADD_ACTION_REQUEST:
      return ih(state, {
        add: {
          isLoading: { $set: true },
        },
      });
    case types.ADD_ACTION_SUCCESS:
      return ih(state, {
        add: {
          isLoading: { $set: false },
        },
      });
    case types.ADD_ACTION_ERROR:
      return ih(state, {
        add: {
          $merge: {
            isLoading: false,
            error: action.payload.error,
          },
        },
      });
    case types.UPDATE_ACTION_REQUEST:
      return ih(state, {
        update: {
          isLoading: { $set: true },
        },
        info: {
          isLoading: { $set: true },
        },
        show: {
          isLoading: { $set: true },
        },
      });
    case types.UPDATE_ACTION_SUCCESS:
      return ih(state, {
        update: {
          isLoading: { $set: false },
        },
        show: {
          isLoading: { $set: false },
          data: {
            $apply: data => {
              const { item } = action.payload;

              return ih(data, {
                [item.id]: {
                  $set: { ...item, order: Number(item.order) + 1 },
                },
              });
            },
          },
        },
        info: {
          $merge: {
            isLoading: false,
            data: {
              ...action.payload.item,
              order: Number(action.payload.item.order) + 1,
            },
          },
        },
      });
    case types.UPDATE_ACTION_ERROR:
      return ih(state, {
        update: {
          $merge: {
            isLoading: false,
            error: action.payload.error,
          },
        },
        info: {
          isLoading: { $set: false },
        },
        show: {
          isLoading: { $set: false },
        },
      });
    case types.GET_ACTION_REQUEST:
      return ih(state, {
        show: {
          isLoading: { $set: true },
        },
      });
    case types.GET_ACTION_SUCCESS:
      return ih(state, {
        show: {
          isLoading: { $set: false },
          data: {
            $apply: data => {
              const { item } = action.payload;

              return ih(data, {
                [item.id]: {
                  $set: { ...item, order: Number(item.order) + 1 },
                },
              });
            },
          },
        },
      });
    case types.GET_ACTION_ERROR:
      return ih(state, {
        show: {
          $merge: {
            isLoading: false,
            error: action.payload.error,
          },
        },
      });
    case types.GET_ACTION_INFO_REQUEST:
      return ih(state, {
        info: {
          isLoading: { $set: true },
        },
      });
    case types.GET_ACTION_INFO_SUCCESS:
      return ih(state, {
        info: {
          $merge: {
            isLoading: false,
            data: {
              ...action.payload.info,
              order: Number(action.payload.info.order) + 1,
            },
          },
        },
      });
    case types.GET_ACTION_INFO_ERROR:
      return ih(state, {
        info: {
          $merge: {
            isLoading: false,
            error: action.payload.error,
          },
        },
      });
    case types.DELETE_ACTION_SUCCESS:
      return ih(state, {
        show: {
          data: {
            $unset: [action.payload.resourceId],
          },
        },
      });
    case SELECT_PROJECT:
      return ih(state, {
        $set: initialState,
      });
    case types.EMPTY_ACTION_INFO:
      return ih(state, {
        info: {
          $set: {},
        },
      });
    case types.MERGE_ACTIONS:
      return ih(state, {
        show: {
          isLoading: { $set: false },
          data: {
            $apply: data =>
              ih(data, {
                $merge: keyBy(action.payload.item, 'id'),
              }),
          },
        },
      });
    case SYNC_FIELDS_SUCCESS: {
      return handleSyncFieldsSuccess(state, action);
    }
    case UPDATE_FIELD_SUCCESS: {
      const fieldUpdated = action.payload.item;
      return ih(state, {
        show: {
          data: {
            $apply: data =>
              Object.entries(data).reduce((acc, [actionId, actionData]) => {
                const updatedActionData = { ...actionData };

                updatedActionData.fields = actionData.fields
                  ? updateFieldsList(actionData.fields, fieldUpdated)
                  : null;

                if (actionData.custom_module_call) {
                  updatedActionData.custom_module_call = {
                    input_fields: updateFieldsList(
                      actionData.custom_module_call.input_fields,
                      fieldUpdated,
                    ),
                    output_fields: updateFieldsList(
                      actionData.custom_module_call.output_fields,
                      fieldUpdated,
                    ),
                  };
                }

                acc[actionId] = updatedActionData;
                return acc;
              }, {}),
          },
        },
      });
    }
    default:
      return state;
  }
};
